module.exports = __webpack_public_path__ + "img/hbao3.a5a15959.png";